<template>
  <div class="appointment">
    <Navbar title="预约详情"></Navbar>
    <!-- 日历 -->
    <div class="calendar">
      <div class="title">选择日期</div>
      <van-calendar
        row-height="30"
        :show-title="false"
        :show-subtitle="false"
        :poppable="false"
        :show-confirm="false"
        :style="{ height: '290px' }"
        @confirm="handleCalendar"
      />
    </div>
    <!-- 预约项目 -->
    <div class="appointment-item">
      <van-row justify="space-between" type="flex">
        <van-col
          v-for="(item, index) in appointmentItem"
          :key="index"
          :class="bthActive === index ? 'active' : ''"
          @click="handleToggleTAb(index)"
        >
          <div>{{ item }}</div>
        </van-col>
      </van-row>
    </div>
    <!-- 预约详情 -->
    <div
      class="appointment-detail"
      v-for="(items, key) in appointmentList"
      :key="key"
    >
      <div class="date">{{ key }}</div>
      <div class="user-info">
        <div v-for="(item, index) in items" :key="index">
          <van-row
            justify="space-between"
            type="flex"
            v-if="item.category === bthActive + 1"
          >
            <van-col span="8">
              {{ item.vehicleBrand + item.vehicleSeries }}
            </van-col>
            <van-col span="8">{{ item.plateNum }} </van-col>
            <van-col span="8">{{ item.phone }} </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <!-- 预约相关设置 -->
    <div class="setting">
      <router-link to="/appointment/appointmentSetting">
        设置预约时间段
      </router-link>
      <router-link to="/appointment/restSetting">
        设置休息时间
      </router-link>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import { appointmentList } from "@/api/appointment";
export default {
  components: {
    Navbar
  },
  data() {
    return {
      appointmentList: [],
      appointmentItem: ["洗车清洁", "爱车保养", "车辆维修"],
      bthActive: 0,
      invalidDate: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      let date = new Date();
      this.handleCalendar(date);
    },
    // 预约列表
    handleAppointmentList(date) {
      // let data = {
      //   date: "",
      //   vehicleList: [],
      // };
      appointmentList(date).then(res => {
        // console.log("预约列表:", res);
        let map = {};
        res.forEach(val => {
          let key = `${val.startTime}-${val.endTime}`;
          if (map[key]) {
            map[key].push(val);
          } else {
            map[key] = [val];
          }
        });
        this.appointmentList = map;
      });
    },
    // 日期选择
    handleCalendar(date) {
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let year = date.getFullYear();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      let invalidDate = year + "-" + month + "-" + day;
      this.handleAppointmentList(invalidDate);
    },
    // 切换标签
    handleToggleTAb(index) {
      this.bthActive = index;
    }
  }
};
</script>
<style lang="scss" scoped>
.appointment {
  .header {
    margin-bottom: 20px;
  }

  .setting {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background-color: #eeeeee;
    display: flex;
    justify-content: space-around;
    align-items: center;
    a {
      flex: 1;
      color: #989898;
    }
    a:first-child {
      border-right: 2px solid #cecece;
    }
  }

  .calendar {
    padding: 0 20px;

    .title {
      margin-bottom: 5px;
      text-align: left;
      font-size: 12px;
      color: #007aff;
    }
  }

  .appointment-item {
    padding: 0 20px;
    margin-bottom: 20px;

    .active {
      background-color: #007aff;
      color: #fff;
    }
  }

  .appointment-detail {
    padding: 0 20px;
    margin-bottom: 20px;

    .date {
      margin-bottom: 5px;
      text-align: left;
      color: #989898;
      font-size: 12px;
    }

    .user-info {
      padding: 10px;
      background-color: #f6f7f9;
    }
  }
}
</style>
<style lang="scss">
.appointment {
  .calendar {
    .van-calendar {
      margin-bottom: 20px;
      background-color: #f6f7f9;
      border-bottom: 1px solid #f6f7f9;
      border-radius: 5px;

      .van-calendar__header {
        background-color: #f6f7f9;
      }

      .van-calendar__selected-day {
        width: 30px;
        height: 30px;
        line-height: 30px;
      }
    }
  }

  .appointment-item {
    .van-col {
      padding: 10px 15px;
      background-color: #f6f7f9;
    }
  }

  .appointment-detail {
    .user-info {
      .van-col {
        padding: 5px 0;
      }

      .van-col:first-child {
        text-align: left;
      }
    }
  }
}
</style>
